import { api } from "./api.service";

export async function requestPasswordReset(email: string) {
  const { data } = await api.post("/auth/forgot-password", { email });
  return data;
}

export async function resetPassword(params: {
  token: string;
  password: string;
  confirmPassword: string;
}) {
  const { data } = await api.post("/auth/reset-password", {
    token: params.token,
    password: params.password,
    confirmPassword: params.confirmPassword,
  });
  return data;
}
